<template>
  <div class="container">
    <div class="section-space-25"></div>
    <div class="section-header-title">Investors Section - Annual Return</div>
    <!-- <div class="section-space-25"></div> -->
    <table>
      <thead>
        <tr>
          <!-- <th>Investor Information Type</th>
        <th>Investor Information Details</th> -->
          <th class="sr-no">Sr. No.</th>
          <th>Particulars</th>
          <th>Download PDF</th>
        </tr>
      </thead>
      <tbody>
        <!-- Example row -->
        <tr v-if="investors.length < 1">
          <td colspan="3" style="text-align: center">
            <strong> No records found</strong>
          </td>
        </tr>
        <tr
          v-for="(investor, index) in investors"
          :key="investor.InvestorInformationType_ID"
        >
          <!-- <td>{{investor.InvestorInformationType}}</td>
        <td>{{investor.InvestorInformationDetails}}</td> -->
          <td class="sr-no center">{{ index + 1 }}</td>

          <td>{{ investor.InvestorInformation_Year }}</td>
          <td class="center">
            <a
              :href="investor.InvestorInformationDocumentPath"
              :download="getFilename(investor.InvestorInformationDocumentPath)"
              >Download</a
            >
          </td>
        </tr>
      </tbody>
    </table>
      <section>
      <div>
        <div class="section-space-25"></div>
      </div>
    </section>
  </div>
</template>
<script>
import ExtrasService from "@/apiServices/ExtrasService";
import { BASEURL } from "@/config";
// import InvestorsService from "@/apiServices/InvestorsService";

export default {
  data() {
    return {
      investors: {
        //  InvestorInformationType: null,
        //  InvestorInformationDetails: null,
        InvestorInformationType_ID: null,
        InvestorInformation_Year: null,
        InvestorInformationDocumentPath: null,
      },
    };
  },
  beforeMount() {
    this.getInvestors();
  },
  computed: {},
  methods: {
    getFilename(path) {
      return path.split("/").pop();
    },
    async getInvestors() {
      try {
        const response = await ExtrasService.getInvestors();
        console.log({ response });
        if (response.data.status) {
          this.investors = response.data.data;
        }
      } catch (err) {
        console.log("Error in getting contact us html ", err);
      }
    },
  },
};
</script>
<style scoped>
h1 {
  text-align: center;
  margin-bottom: 20px;
}
table {
  width: 100%;
  margin: 20px 0;
  border-collapse: collapse;
}
th,
td {
  border: 1px solid #d19c97;
  text-align: left;
  padding: 12px;
}
td.center {
  text-align: center;
}
th {
  background-color: #d19c97;
  color: black;
  text-align: center;
   border: 1px solid  black;
}
td a img {
  width: 20px;
  height: auto;
}
table th.sr-no,
table td.sr-no {
  width: 70px; /* Adjust the width as needed */
}
</style>


// WEBPACK FOOTER //
// src/components/pages/investors.vue